import React from "react";

export default (props) => {

  return (
    <React.Fragment>

      <h1 className="page-title">Cookie policy</h1>
      <p>Cookies are files saved on your phone, tablet or computer when you visit a website.</p>
      <p>We use cookies to temporarily store information about how you use MyScan so that your visit is more effective.</p>
      <p>We don't use any cookies on MyScan that contain information which identifies you personally.</p>
      <h4>Cookie settings</h4>
      <p>
        <strong>How to disable cookies</strong><br />
        Full instructions on how to delete and control your cookies in all the main web browsers can be found on the aboutcookies.org website.
      </p>
      <p>
        <strong>What happens if cookies are disabled?</strong><br />
        This depends on which cookies you disable, but in general the site may not operate properly if cookies are switched off. If you disable all cookies, you will be unable to complete a transaction on this site.
      </p>
      <h4>Cookies on MyScan</h4>
      <p>We only use strictly necessary cookies within MyScan. These essential cookies do things like remember your progress through a form (for example: providing evidence for a benefit application). They always need to be on.</p>
      <p>These cookies help our web application to run smoothly, but we do not use the information collected to identify or track individuals. Most of the cookies that are created when you use our web app are called 'session cookies'. These are cookies which expire when you leave the web app (they only exist during your visit, also called a 'session').</p>
      <p>Behavioural and advertising cookies - We do not use any behavioural or advertising cookies on the MyScan web app.</p>

    </React.Fragment>
  );
}
